import axios from 'axios';
import md5 from 'md5';
import config from './config.js';
import { assignParams } from '@/common/js/util.js';
import {valueCheck,timest,encodeSearchParams,sortObj,trimArray} from './common.js';

let md5Key = 'UN2jVTFv5O9zLZiOFpr4uzDnLedu9g8t'; //MD5key值
axios.defaults.baseURL = config.api_url;   //API域名 开发环境
axios.defaults.timeout = 10000;                       //响应时间
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';        //配置请求头

function md5Verify (data,sign) {
	const cre_sign = md5("response=" + encodeURIComponent(data) + "&sign=" + md5Key);
	if (cre_sign != sign) {
		return false;
	}
	return true;
}
//接口请求入口
export default {
	install(Vue,router) {
		Vue.prototype.$ajax = function(params) {
			if (!valueCheck(params.method)) {
				return false;
			}
			params['x_method'] = params.method;
			const merchantinfo = JSON.parse(localStorage.getItem('tokenInfo')) || {};
			let postData = {
				x_account_type	: 'common',
				x_app 			: '1.0',
				x_merchant_no	: 0,
				x_method		: '',
				x_result_en 	: 0, //数据是否AES加密
				x_sign_type 	: 'md5',
				x_time 			: timest(),
				x_uuid 			: '1.0',
				x_version 		: '1.0',
				//用户角色必填
				x_token			: 0,
				x_sid			: 0,
				//商户角色必填
				x_m_token		: 0,
			}
			assignParams(postData, merchantinfo);
			assignParams(postData, params)
		

			if (valueCheck(params.data)) {
				params.data = trimArray(params.data);
				postData = Object.assign(postData, params.data);
			}
			const sortData = encodeSearchParams(sortObj(postData));
			postData.x_sign = md5(`${sortData}&sign=${md5Key}`);
			
			return new Promise((resolve, reject) => {
				axios.post('/api/external', postData).then(function (res) {
					if (!valueCheck(res.data.response) || !valueCheck(res.data.sign)) {
						reject('data not exist')
					}
					if (!md5Verify(res.data.response,res.data.sign)) {
						reject('check sign error')
					}
					let resDes = JSON.parse(res.data.response)
					//如果token过期，则跳转到登陆页面
					if (resDes.status == 403) {
						router.push({ path: '/login'})
					}else if(resDes.status == 40200){
						router.push({ path:'/select'});
					}else if(resDes.status == 40201){
                        router.push({ path:'/select'});
                    }else if(resDes.status == 40202){
                        router.push({path:'/setting/licenseOrder'});
                    }
                    resolve(resDes);
				})
				.catch(function (error) {
					reject(error);
				});
			})
		}




		Vue.prototype.$apis = function(params) {
			if (!valueCheck(params)) {
				return false;
			}
			let postData = params;
			// let userinfo = uni.getStorageSync('accountInfo')

			const merchantinfo = JSON.parse(localStorage.getItem('tokenInfo')) || {};
			let getParams = {
				x_account_type	: 'common',
				x_app 			: '1.0',
				x_merchant_no	: 0,
				x_method		: '',
				x_result_en 	: 0, //数据是否AES加密
				x_sign_type 	: 'md5',
				x_time 			: timest(),
				x_uuid 			: '1.0',
				x_version 		: '1.0',
				//用户角色必填
				x_token			: 0,
				x_sid			: 0,
				//商户角色必填
				x_m_token		: 0,
			}
			assignParams(getParams, merchantinfo);
			assignParams(getParams, params)

			for (let i in postData) {
				const subData = postData[i];
				const apiParams = subData.params || {};
				const apiMethod = {
				  x_method		: subData.x_method,
				  x_account_type: subData.x_account_type || 'merchant',
				  x_version		: subData.x_version || '1.0',
				}
				
				const signDataObj = Object.assign({},getParams, apiParams, apiMethod);
				const sortData = encodeSearchParams(sortObj(signDataObj));
				postData[i].x_sign = md5(`${sortData}&sign=${md5Key}`);
				postData[i] = Object.assign({}, subData, apiMethod,{'params':apiParams});

			}
			// console.log(postData);
			return new Promise((resolve, reject) => {
				axios.post('/api/external?'+encodeSearchParams(getParams), postData).then(function (res) {
					// console.log(res);
					if (!valueCheck(res.data.response) || !valueCheck(res.data.sign)) {
						reject('data not exist')
					}
					if (!md5Verify(res.data.response, res.data.sign)) {
						reject('check sign error')
					}

					if (md5Verify(res.data.response, res.data.sign)) {
						if (params.encrypt) {
							res.data.response = AES.Decrypt(res.data.response); //如果数据已加密，需要先解密
							if (!res.data.response) {
								reject('aes decrypt error')
							}
						}
						let dataList = JSON.parse(res.data.response)
						// console.log('datalist', dataList);
						for (let x in dataList) {
							let response = dataList[x].response

							if (response.status == 403 || response.status == 411) {
								router.push({ path: '/login'})
							}else if(response.status == 40200){
								router.push({ path:'/select'});
							}else if(response.status == 40201){
								router.push({ path:'/select'});
							}else if(response.status == 40202){
								router.push({path:'/setting/licenseOrder'});
							}
							dataList[x] = response
						}
						resolve(dataList)
					} else {
						reject('check sign error')
					}
				})
				.catch(function (error) {
					reject(error);
				});
			})
		}
	}
}



// WEBPACK FOOTER //
// ./src/api/api.js